export default __webpack_public_path__ + "img/android-chrome-512x512.094f3886.png";